import { Injectable } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { AuthorizationService } from "@core/services/authorization.service";
import { ClaimsColumnsService } from "../../layout/claims/services/claims-columns.service";
import { PaymentsColumnsService } from "../../layout/payments/services/payments-columns.service";
import { UsersColumnsService } from "../../layout/users/services/users-columns.service";

@Injectable()
export class ConfigurationFormBuilderService {
	constructor(
		private formBuilder: UntypedFormBuilder,
		private claimsColumnsService: ClaimsColumnsService,
		private paymentsColumnsService: PaymentsColumnsService,
		private usersColumnsServices: UsersColumnsService,
		private authorizationService: AuthorizationService
	) {}

	public getForm(): UntypedFormGroup {
		const form = this.formBuilder.group({
			claimColumns: this.getClaimsForm(),
			paymentsColumns: this.getPaymentsForm(),
		});
		if (this.authorizationService.isSuper) {
			form.addControl("usersColumns", this.getUsersForm());
		}
		return form;
	}

	public getClaimsForm(): UntypedFormGroup {
		const visibleColumns = this.claimsColumnsService.restore();
		return this.formBuilder.group({
			id: [visibleColumns.includes("id")],
			payerNumber: [visibleColumns.includes("payerNumber")],
			invoiceDate: [visibleColumns.includes("invoiceDate")],
			dueDate: [visibleColumns.includes("dueDate")],
			fullName: [visibleColumns.includes("fullName")],
			description: [visibleColumns.includes("description")],
			sum: [visibleColumns.includes("sum")],
			paymentSum: [visibleColumns.includes("paymentSum")],
		});
	}

	public getUsersForm(): UntypedFormGroup {
		const columns = this.usersColumnsServices.restore();
		return this.formBuilder.group({
			clientName: columns.includes("clientName"),
			clientLogin: columns.includes("clientLogin"),
			clientEmail: columns.includes("clientEmail"),
			clientPhoneNumber: columns.includes("clientPhoneNumber"),
			clientTypeDescription: columns.includes("clientTypeDescription"),
			clientSupplierName: columns.includes("clientSupplierName"),
			clientBlocked: columns.includes("clientBlocked"),
			clientDateAdd: columns.includes("clientDateAdd"),
		});
	}

	public getPaymentsForm(): UntypedFormGroup {
		const visibleColumns = this.paymentsColumnsService.restore() || [];
		return this.formBuilder.group({
			accountNumber: [visibleColumns.includes("accountNumber")],
			bankCode: [visibleColumns.includes("bankCode")],
			paymentDocumentNumber: [visibleColumns.includes("paymentDocumentNumber")],
			paymentDocumentDate: [visibleColumns.includes("paymentDocumentDate")],
			paymentDate: [visibleColumns.includes("paymentDate")],
			paymentSum: [visibleColumns.includes("paymentSum")],
			commissionSum: [visibleColumns.includes("commissionSum")],
			transferSum: [visibleColumns.includes("transferSum")],
			refundAvailableSum: [visibleColumns.includes("refundAvailableSum")],
			refundSum: [visibleColumns.includes("refundSum")],
			fullName: [visibleColumns.includes("fullName")],
			address: [visibleColumns.includes("address")],
			description: [visibleColumns.includes("description")],
			claimId: [visibleColumns.includes("claimId")],
			paymentId: [visibleColumns.includes("paymentId")],
			providerOperId: [visibleColumns.includes("providerOperId")],
			authorizationType: [visibleColumns.includes("authorizationType")],
			serviceProvision: [visibleColumns.includes("serviceProvision")],
		});
	}
}
